import { useToastNotification } from "lib/hooks";
import { useUpgradeContext } from 'domains/subscription';

export const useNotificaitons = () => {
  const { errorToast } = useToastNotification();
  const { openUpgradeModal } = useUpgradeContext()

  const storageLimitNotification = () => errorToast({
    title: <>You’ve reached storage capacity on your current Packs plan. To add more storage, <a href="mailto:support@packs.co" className="alert--contact-us">contact us</a></>,
    duration: null,
  });

  return {
    assetLimitNotification: openUpgradeModal,
    storageLimitNotification,
  }
};
